export var injectEdgeAuthHeaders = function injectEdgeAuthHeaders(headers) {
  return {
    "x-cg-sales-channel": headers["x-cg-sales-channel"] || "",
    "x-cg-sales-channel-id": headers["x-cg-sales-channel-id"] || "",
    "x-cg-device-id": headers["x-cg-device-id"] || "",
    "x-cg-base-url": headers["x-cg-base-url"] || "",
    "x-cg-customer-id": headers["x-cg-customer-id"] || ""
  };
};